<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

import { LANGUAGEMETA } from '@/utils/meta'

import { useIdeStore } from '@/stores/ide.store'

const props = defineProps({
  secondaryStyle: {
    type: Boolean,
    default: false
  },
  isProfileMenu: {
    type: Boolean,
    default: false
  }
})

const ideStore = useIdeStore()

/**
 * returns the default IDE language url
 */
const goToIdeOptions = () => {
  const ideSettings = ideStore.ideSettings

  if (ideSettings && ideSettings.defaultLanguage) {
    const meta = LANGUAGEMETA[ideSettings.defaultLanguage]
    if (meta) {
      if (meta.canonicalPath) {
        router.push(('/' + meta.canonicalPath) as string)
      } else {
        router.push('/start-coding')
      }
    } else {
      router.push('/start-coding')
    }
  } else {
    router.push('/start-coding')
  }
}
</script>

<template>
  <button
    :class="[
      {
        'bg rounded border-none bg-new-secondary-600 px-5 py-4 text-base font-medium leading-none text-white transition-colors hover:bg-new-secondary-400':
          !props.secondaryStyle && !props.isProfileMenu,
        'rounded border-2 border-new-secondary-600 px-3 py-2.5 text-sm font-medium leading-none text-new-secondary-600 transition-colors hover:bg-new-secondary-50':
          props.secondaryStyle,
        'text-button-secondary hover:surface-primary-header hover:text-high block w-full rounded py-1.5 pl-[3.25rem] text-left text-sm font-medium md:pl-9':
          props.isProfileMenu
      }
    ]"
    @click="goToIdeOptions"
  >
    <span v-if="isProfileMenu">IDE</span>
    <span v-else>Let's Code</span>
    <FontAwesomeIcon
      v-if="!props.secondaryStyle && !props.isProfileMenu"
      icon="fa-arrow-right"
      class="ms-2"
    />
  </button>
</template>
